import React, { Component } from "react";
import { withLocalize } from "react-localize-redux";
import "./style.scss";

class PopupChartSetting extends Component {

    addCondition = (e) => {
    }

    removeCondition = (e) => {
    }

    componentDidMount = () => {
        this.commonHideComponent('chat-setting', 'popup_inner');
    }

    commonHideComponent = (p, c) => {
        const wrapWorkspace = document.getElementById(p);
        const workspace = document.getElementById(c);
        const self = this;
        wrapWorkspace.addEventListener('click', function (event) {
            const isClickInside = workspace.contains(event.target);
            if (!isClickInside) {
                self.closePopup();
            }
        });
    }

    closePopup = () => {
        this.props.closePopup();
    }
    

    render() {
        return (
            <div className='chart-setting popup' id='chat-setting'>
                <div className='popup_inner' id='popup_inner'>
                    <h3 className="title-popup">絞り込み条件 Filter</h3>
                    <div className="line-1">
                        <select className="form-control">
                            <option>シーズン</option>
                            <option>シーズン</option>
                            <option>シーズン</option>
                            <option>シーズン</option>
                        </select>
                        <input type="text" className="input-form" name="name" placeholder="値" />
                        <img onClick={this.removeCondition} src="/img/ic_delete2.png" alt="Alt text" />
                    </div>
                    <div className="line-2">
                        <button onClick={this.addCondition} >条件を追加</button>
                    </div>
                    <div className="line-3">
                        <div className="md-checkbox-custom">
                            <input id="i2" type="checkbox" />
                            <label htmlFor="i2">期間</label>
                        </div>
                        <input type="date" defaultValue="2019-08-06" className="time-option" />
                        <span>〜</span>
                        <input type="date" defaultValue="2019-08-06" className="time-option" />
                    </div>
                    <div className="button">
                        <p onClick={() => this.closePopup()}>キャンセル</p>
                        <p>更新</p>
                    </div>
                </div>
            </div>
        )
    }
}

export default withLocalize(PopupChartSetting);